// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBhp1Mk4cGqDck3wOT4pB5rL8QkS8qD2-A",
    authDomain: "ideal-institute-delhi.firebaseapp.com",
    databaseURL: "https://ideal-institute-delhi-default-rtdb.firebaseio.com",
    projectId: "ideal-institute-delhi",
    storageBucket: "ideal-institute-delhi.firebasestorage.app",
    messagingSenderId: "689181900471",
    appId: "1:689181900471:web:4fc8cdda558cb04b425732",
    measurementId: "G-4JGGDHPZE5"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
